import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { DataExtractionService } from '@/infra/services/data-extraction';

interface GetDataExtractionSelectedReportsCountParams {
	organization_id: string;
	data_extraction_id?: string;
}

const Service = DataExtractionService.getInstance();

export function useGetDataExtractionSelectedReportsCount(params: GetDataExtractionSelectedReportsCountParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_DATA_EXTRACTION_SELECTED_REPORTS_COUNT, params],
		queryFn: () => Service.getDataExtractionReportsSelectedCount(params)
	});
}
